import { MonetaryZone, CreateCountryDto } from "../models/MonetaryZones";
import axiosInstance from "./axiosInstance";

const createMonetaryZones = async (zone: Partial<MonetaryZone>) => {
  const response = await axiosInstance.post("monetary-zones/create", zone);
  return response.data;
};

const getAllMonetaryZones = async () => {
  const response = await axiosInstance.get("monetary-zones/all");
  return response.data;
};

const updateMonetaryZones = async (
  moneteryZoneId: string,
  updatedData: Partial<MonetaryZone>
) => {
  const response = await axiosInstance.patch(
    `monetary-zones/update/${moneteryZoneId}`,
    updatedData
  );
  return response.data;
};

const deleteMonetaryZone = async (monetaryZoneId: string) => {
  const response = await axiosInstance.delete(
    `monetary-zones/delete/${monetaryZoneId}`
  );
  return response.data;
};

const getZoneById = async (zoneId: string) => {
  const response = await axiosInstance.get(`monetary-zones/${zoneId}`);
  return response.data;
};

const createCountry = async (zone: Partial<CreateCountryDto>) => {
  const response = await axiosInstance.post("countries/create", zone);
  return response.data;
};

const getAllCountry = async () => {
  const response = await axiosInstance.get("countries/all");
  return response.data;
};

const updateCountry = async (
  countryId: string,
  updatedData: Partial<CreateCountryDto>
) => {
  const response = await axiosInstance.patch(
    `countries/update/${countryId}`,
    updatedData
  );
  return response.data;
};

const deleteCountry = async (countryId: string) => {
  const response = await axiosInstance.delete(`countries/delete/${countryId}`);
  return response.data;
};

const getCountryById = async (countryId: string) => {
  const response = await axiosInstance.get(`countries/${countryId}`);
  return response.data;
};

const getUserCountries = async (customerId: string) => {
  const response = await axiosInstance.get(
    // `countries/get-countries/${customerId}`
    `countries/available/all`
  );
  return response.data;
};

export const monetaryZonesServices = {
  createMonetaryZones,
  getAllMonetaryZones,
  updateMonetaryZones,
  deleteMonetaryZone,
  getZoneById,
  createCountry,
  getAllCountry,
  updateCountry,
  deleteCountry,
  getCountryById,
  getUserCountries,
};
